'use strict';

var util = require('./util');
var iscrollWrapper = document.getElementById('iscroll-wrapper'),
	$innerWrapper = $('.inner-iscroll-wrapper'),
	myScroll; //declare placeholder for your IScroll instance globally, so you have an access to it from everywhere within the module


function initializeEvents() {

	/************************************************************
	 * Demonstrate the case when the area doesn't require
	 * scroll-bar anymore
	 ***********************************************************/
	$('.leave-3-items-only').click(function () {
		if ($('.iscroll-item').length < 4) { return; }
		$('.iscroll-item').filter(':gt(2)').remove();

		myScroll.scrollTo(0, 0); //option call; used to scroll content up to the top

		/*
		 * When items length decreases, it may reach threshold where using IScroll
		 * no longer needed, in this case IScroll should be destroyed to remove custom scroll-bar
		 * IScroll var holding IScroll instance may also be set to "null", so with each subsequent
		 * dynamic change of the length of the items, you can check whether  to init or refresh IScroll
		 */
		myScroll.destroy();
		myScroll = null;

		//update the total count of the blocks inside scroll area
		$('.iscroll-items-count').html($('.iscroll-item').length);
	});

	/************************************************************
	 * Demonstrate the case when the number of the items inside
	 * scroll area dynamically change
	 ***********************************************************/
	$('.add-10-items-more').click(function () {
		var lastIndex = parseInt($('.iscroll-item:last').find('.index').html()),
			i = 0;

		while (i < 10) {
			lastIndex++;
			$innerWrapper.append($('<div class="iscroll-item">BLOCK <span class="index">' + lastIndex +
			'</span><input type="text" size="30" style="width:auto; margin-left:20px"/>' +
			'<button class="change-color" style="float:right; margin-right:10px">Interact with block</button></div>'));
			i++;
		}

		/*
		 * Once the length of the items has changed, IScroll should be refreshed.
		 * If IScroll was deleted previously/not inited at all, it should be re-init (helpful in re-usable functions)
		 * For better performance, it may also be required to wrap the refresh in timeout, when DOM process of re-rendering
		 * can be deferred (animation/ajax calls)
		 */
		if (myScroll) {
			setTimeout(function () {
				myScroll.refresh();
			}, 5);
		} else {
			if (iscrollWrapper) {
				myScroll = new IScroll(iscrollWrapper, util.iscrollParams());
			}
		}

		//update the total count of the blocks inside scroll area
		$('.iscroll-items-count').html($('.iscroll-item').length);
	});

	/************************************************************
	 * Demonstrate the ability to interact with the buttons,
	 * links inside the scroll area
	 ***********************************************************/
	$('.iscroll-item .change-color').click(function () {
		$(this).parent().toggleClass('change');
	});
}


function init () {
	/*
	 *  Init IScroll at the moment when area reach threshold so it requires scroll-bar
	 *  (in this case it's a very beginning)
	 */
	if (iscrollWrapper) {
		myScroll = new IScroll(iscrollWrapper, util.iscrollParams());
	}

	initializeEvents();

}

exports.init = init;